<template>
  <div>
    <v-autocomplete
      v-model="dadoAtualizado"
      :label="label"
      :items="dadosTabela"
      item-value="valor"
      item-text="valor"
      dense
      no-data-text="Nenhum dado encontrado"
    />
  </div>
</template>

<script>
  export default {
    name: 'InputDicionarioDadosAneel',
    props: {
      label: {
        type: String,
        default: null
      },
      entidadeBdgd: {
        type: String,
        required: true
      },
      campo: {
        type: String,
        required: true
      },
      dadoInicial: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        dadoAtualizado: null
      };
    },
    computed: {
      tabela() {
        return this.$store.getters.getTabelaPorCampo(this.entidadeBdgd, this.campo);
      },
      dadosTabela() {
        return this.$store.getters.getDadosTabela(this.tabela);
      }
    },
    mounted() {
      this.dadoAtualizado = String(this.dadoInicial).trim();
    },
    watch: {
      dadoAtualizado() {
        this.$emit('dadoAlterado', this.dadoAtualizado);
      }
    }
  };
</script>
